// !!!!!!!! Since these functions has rebuy dependencies please call these functions inside REBUY loaded event callback

async function initIpLookup() {
	try {
	  let isInTargetRegion = sessionStorage.getItem("ipGeoLocationData");
  
	  if (isInTargetRegion !== null) return;
  
	  const tryGeolocation = async () => {
		if (typeof Rebuy !== 'undefined' && Rebuy._status === 'initialized' && typeof Rebuy.getGeolocation === 'function') {
		  const lookUpResp = await Rebuy.getGeolocation();
		  sessionStorage.setItem("ipGeoLocationData", JSON.stringify(lookUpResp));
		  return true;
		}
		return false;
	  };
  
	  // First attempt
	  const success = await tryGeolocation();
	  if (!success) {
		// Wait 2 seconds then retry
		await new Promise(resolve => setTimeout(resolve, 2000));
		await tryGeolocation(); // Second attempt
	  }
  
	} catch (error) {
	  console.log('IP Lookup error:', error);
	}
  }
  

  async function isInTargetRegion(targets = [""]) {
	try {
		if (!targets.length) return false;

		let geoData = sessionStorage.getItem("ipGeoLocationData");

		if (!geoData) {
			await initIpLookup();
			geoData = sessionStorage.getItem("ipGeoLocationData");
		}

		if (!geoData) return null; // couldn't determine location

		const location = JSON.parse(geoData);
		if (!location || !location.country_name) return null;

		return targets.some((t) => {
			const target = t.trim().toLowerCase();
			return (
				location.city_name?.toLowerCase() === target ||
				location.province_name?.toLowerCase() === target ||
				location.country_name?.toLowerCase() === target
			);
		});
	} catch (error) {
		console.log("isInTargetRegion error:", error);
		return null; // treat as unknown on error
	}
}

